import Vue from "vue";
import moment from "moment";




// The -mobile component avoid a HTML input because that pops up a VKB and shows a cursor -> we don't want that on the phone
Vue.component("date-time-input-mobile", {
    props: ["active", "value", "format", "label"],
    computed: {
        calendarClass: function() {
            return ["bg-white", "border-gray-300", "text-gray-600"];
        },
        displayValue: function() {
            return moment(this.value).format(this.format);
        },
    },
    methods: {
        onClick: function(ev) {
            this.$emit("click", ev);
        },
    },
    template:
        '<div class="input-group date">' +
        '<div class="input-group-prepend">' +
        '<span class="input-group-text" v-bind:class="calendarClass"><i class="fa fa-calendar"></i>&nbsp;{{label}}</span>' +
        "</div>" +
        '<div class="form-control" v-on:click="onClick">{{displayValue}}</div>' +
        "</div>",
});

Vue.component("location-input-mobile", {
    props: ["active", "value", "label"],
    computed: {
        locationClass: function() {
            return ["bg-white", "border-gray-300", "text-gray-600"];
        },
    },
    methods: {
        onClick: function(ev) {
            this.$emit("click", ev);
        },
    },
    template:
        '<div class="input-group">' +
        '<div class="input-group-prepend">' +
        '<span class="input-group-text" v-bind:class="locationClass"><i class="fa fa-map-marker"></i>&nbsp;{{label}}</span>' +
        "</div>" +
        '<div class="form-control" v-bind:value="value" v-on:click="onClick">{{value}}</div>' +
        "</div>",
});
